import vmClient from '../../services/vmClient';
import { IExternalAssociation } from '../../types/entity';
import { Category } from './Category';

export const CurriculumCategories: IExternalAssociation = vmClient.defineExternalAssociation({
  typeName: 'CurriculumCategories',
  associationType: Category,
});
